export default __webpack_public_path__ + "static/media/noimage.a42d0c11.png";